<template>
  <div class="End  full-height">
    <Page class="End__page">
      <div class="End__content full-height">
        <transition name="u-fade-in">
          <img
            v-if="show.logo"
            class="End__logo"
            alt="glenlivet logo"
            src="../assets/logo.png"
          />
        </transition>
        <transition name="u-fade-in">
          <img
            v-if="show.emblem"
            class="End__diamond"
            alt="animated folding diamond emblem"
            src="../assets/diamond-gif.gif"
          />
        </transition>

        <transition name="u-fade-in">
          <img
            v-if="show.logo"
            class="End__image"
            alt="This is the end of our journey"
            src="../assets/end-text.svg"
          />
        </transition>
        <transition name="u-fade-in">
          <p v-if="show.intro">
            Join us to be amongst the first to know The Glenlivet Spectra’s full tasting notes.
          </p>
        </transition>
        <div class="End__cta-wrapper">
          <transition name="u-fade-in">
            <a
              href="https://www.theglenlivet.com/en-EN/our-community/join-us"
              target="_blank"
              class="End__cta"
              ><base-button v-if="show.cta" theme="chard"
                >Join us</base-button
              ></a
            >
          </transition>
          <transition name="u-fade-in">
            <a @click.prevent="onTasteAgain" class="End__cta"
              ><base-button v-if="show.tasteAgain" theme="chard"
                >Taste again</base-button
              ></a
            >
          </transition>
        </div>
        <transition name="u-fade-in">
          <ShareSocialMedia copy="Share" :end="true"></ShareSocialMedia>
        </transition>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from '../components/Page'
import BaseButton from '../components/BaseButton'
import ShareSocialMedia from '../components/ShareSocialMedia'
import { audioMixin } from '../mixins/audioMixin'
export default {
  components: { BaseButton, Page, ShareSocialMedia },
  mixins: [audioMixin],
  data() {
    return {
      show: {
        logo: false,
        emblem: true,
        intro: false,
        cta: false,
        tasteAgain: false
      },
      transitionDuration: 0,
      transitionDelay: 100
    }
  },
  mounted() {
    this.startAnimation()
  },
  methods: {
    onTasteAgain() {
      this.playSound(`bottle-selection-start`)
      sessionStorage.removeItem('glenlivet_state')
      this.$router.push({ path: 'bottle-selection' })
    },
    startAnimation() {
      setTimeout(() => {
        this.show.logo = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.intro = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.cta = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.tasteAgain = true
      }, (this.transitionDuration += this.transitionDelay))
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';

.End {
  background: url('../assets/start-bg.png') no-repeat 50%;
  background-size: 100%;
  width: 100vw;
  max-height: 100%;
  overflow: hidden;

  &__logo {
    margin-bottom: 20px;
    width: 165px;
  }

  &__diamond {
    margin-bottom: 20px;
    width: 120px;
  }

  &__image {
    margin-bottom: 20px;
  }

  &__cta-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  &__cta {
    width: 135px;

    .BaseButton {
      width: 100%;
    }
  }

  &__link {
    display: inline-block;
    font-family: $secondary-font;
    text-transform: uppercase;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 1.29px;
    position: relative;
    text-decoration: none;
    padding-bottom: 5px;

    &:after {
      background-image: $chard-gradient;
      content: ' ';
      position: absolute;
      bottom: 0;
      height: 2px;
      width: 100%;
      left: 0;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    text-align: center;
    padding: 20px 10px;
    box-sizing: border-box;

    p {
      color: $light-font-color;
      font-family: $secondary-font;
      font-size: 16px;
      text-align: center;
      margin: 0 auto 35px auto;
      max-width: 290px;
      letter-spacing: 0.3px;
      line-height: 1.2;
    }

    .BaseButton {
      margin-bottom: 42px;
    }
  }
}
</style>
